import { Paper, Stack, Title, ThemeIcon } from "@mantine/core"
import { IconBriefcaseOff } from "@tabler/icons-react"

export const EmptyBudgetTable = () => (
  <Paper
    h="60vh"
    styles={{ root: { overflowY: "scroll" } }}
    p={0}
    bg="surfaceCard"
  >
    <Stack align="center" mt="20vh">
      <ThemeIcon size={60} variant="light" color="primaryHighlight">
        <IconBriefcaseOff size={40} />
      </ThemeIcon>
      <Title order={3}>Select a virtual dimension to start</Title>
    </Stack>
  </Paper>
)
